import request from '@/util/request';
import qs from 'qs';

// 分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/calltask/page', Object.assign({}, options, { params }));

// 详情
export const getDetailApi = (params, options) =>
  request.get('/api/v4ward/callcenter/calltask/detail', Object.assign({}, options, { params }));

// 新增
export const addApi = (formData) => {
  return request({
    url: '/api/v4ward/callcenter/calltask/submit',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
};

// 关闭
export const closeApi = (params, options) =>
  request.post('/api/v4ward/callcenter/calltask/close', params, options, {
    ContentType: 'application/json',
  });

// 外呼日志分页列表
export const getLogPageListApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/calltaskdetaillog/page',
    Object.assign({}, options, { params })
  );
